import React, {Component, Fragment} from 'react';
import ChangePasswordDetail from './changePasswordDetail';

class ChangePassword extends Component{
    render(){
        return(
            <Fragment>
                <div style={{backgroundColor:'#f4f6f9', minHeight: '100vh'}}>
                    <ChangePasswordDetail />
                </div>
            </Fragment>
        )
    }
}

export default ChangePassword;